var _regeneratorRuntime = require("@babel/runtime/regenerator");

module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = "./src/index.js");
  /******/
}(
/************************************************************************/

/******/
{
  /***/
  "./src/index.js":
  /***/
  function srcIndexJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: external "web-vitals"


    var external_web_vitals_ = __webpack_require__("web-vitals"); // CONCATENATED MODULE: ./src/metrics/onCumulativeLayoutShift.js


    var onCumulativeLayoutShift_onCumulativeLayoutShift = function onCumulativeLayoutShift(response) {
      Object(external_web_vitals_["getCLS"])(function (cls) {
        return response(cls.value);
      });
    };
    /* harmony default export */


    var metrics_onCumulativeLayoutShift = onCumulativeLayoutShift_onCumulativeLayoutShift; // CONCATENATED MODULE: ./src/defer.js

    function defer() {
      var deferred = {
        promise: null,
        resolve: null,
        reject: null
      };
      deferred.promise = new Promise(function (resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
      });
      return deferred;
    }
    /* harmony default export */


    var src_defer = defer; // CONCATENATED MODULE: ./src/metrics/performanceListener.js

    var domCompletePromise = src_defer();
    var domInteractivePromise = src_defer();
    var domLoadingPromise = src_defer();
    var windowOnLoadPromise = src_defer();
    var timeToFirstBytePromise = src_defer();

    function checkEntries(entries) {
      entries.forEach(function (entry) {
        if (entry.domComplete) {
          domCompletePromise.resolve(entry.domComplete - entry.domContentLoadedEventEnd);
        }

        if (entry.domContentLoadedEventStart) {
          domInteractivePromise.resolve(entry.domContentLoadedEventStart - entry.domInteractive);
        }

        if (entry.domInteractive) {
          domLoadingPromise.resolve(entry.domInteractive - entry.unloadEventEnd);
        }

        if (entry.loadEventEnd) {
          windowOnLoadPromise.resolve(entry.loadEventEnd - entry.loadEventStart);
        }

        if (entry.responseStart) {
          timeToFirstBytePromise.resolve(entry.responseStart);
        }
      });
    }

    if (typeof window !== 'undefined') {
      if ("performance" in window) {
        if ("PerformanceObserver" in window) {
          var perfObserver = new PerformanceObserver(function (list) {
            var entries = list.getEntries();
            checkEntries(entries);
          });
          perfObserver.observe({
            entryTypes: ['navigation']
          });
        } else if (window.onload) {
          window.onload(function () {
            var entries = performance.getEntriesByType('navigation');
            checkEntries(entries);
          });
        }
      }
    }

    var getDomComplete = function getDomComplete() {
      return domCompletePromise.promise;
    };

    var getDomInteractive = function getDomInteractive() {
      return domInteractivePromise.promise;
    };

    var getDomLoading = function getDomLoading() {
      return domLoadingPromise.promise;
    };

    var getWindowLoad = function getWindowLoad() {
      return windowOnLoadPromise.promise;
    };

    var getTimeToFirstByte = function getTimeToFirstByte() {
      return timeToFirstBytePromise.promise;
    }; // CONCATENATED MODULE: ./src/metrics/onDomComplete.js


    var onDomComplete_onDomComplete = function onDomComplete(response) {
      getDomComplete().then(function (domComplete) {
        return response(domComplete);
      });
    };
    /* harmony default export */


    var metrics_onDomComplete = onDomComplete_onDomComplete; // CONCATENATED MODULE: ./src/metrics/onDomInteractive.js

    var onDomInteractive_onDomInteractive = function onDomInteractive(response) {
      getDomInteractive().then(function (domInteractive) {
        return response(domInteractive);
      });
    };
    /* harmony default export */


    var metrics_onDomInteractive = onDomInteractive_onDomInteractive; // CONCATENATED MODULE: ./src/metrics/onDomLoading.js

    var onDomLoading_onDomLoading = function onDomLoading(response) {
      getDomLoading().then(function (domLoading) {
        return response(domLoading);
      });
    };
    /* harmony default export */


    var metrics_onDomLoading = onDomLoading_onDomLoading; // CONCATENATED MODULE: ./src/metrics/onFirstContentfulPaint.js

    var onFirstContentfulPaint_onFirstContentfulPaint = function onFirstContentfulPaint(response) {
      Object(external_web_vitals_["getFCP"])(function (fcp) {
        return response(fcp.value);
      });
    };
    /* harmony default export */


    var metrics_onFirstContentfulPaint = onFirstContentfulPaint_onFirstContentfulPaint; // CONCATENATED MODULE: ./src/metrics/onFirstInputDelay.js

    var onFirstInputDelay_onFirstInputDelay = function onFirstInputDelay(response) {
      Object(external_web_vitals_["getFID"])(function (fid) {
        return response(fid.value);
      });
    };
    /* harmony default export */


    var metrics_onFirstInputDelay = onFirstInputDelay_onFirstInputDelay; // CONCATENATED MODULE: ./src/metrics/onLargestContentfulPaint.js

    var onLargestContentfulPaint_onLargestContentfulPaint = function onLargestContentfulPaint(response) {
      Object(external_web_vitals_["getLCP"])(function (lcp) {
        return response(lcp.value);
      });
    };
    /* harmony default export */


    var metrics_onLargestContentfulPaint = onLargestContentfulPaint_onLargestContentfulPaint; // CONCATENATED MODULE: ./src/metrics/onTimeToFirstByte.js

    var onTimeToFirstByte_onTimeToFirstByte = function onTimeToFirstByte(response) {
      getTimeToFirstByte().then(function (value) {
        return response(value);
      });
    };
    /* harmony default export */


    var metrics_onTimeToFirstByte = onTimeToFirstByte_onTimeToFirstByte; // EXTERNAL MODULE: external "tti-polyfill"

    var external_tti_polyfill_ = __webpack_require__("tti-polyfill"); // CONCATENATED MODULE: ./src/metrics/onTimeToInteractive.js


    var onTimeToInteractive_onTimeToInteractive = function onTimeToInteractive(response) {
      Object(external_tti_polyfill_["getFirstConsistentlyInteractive"])().then(function (durationMs) {
        if (durationMs) {
          response(durationMs);
        }
      });
    };
    /* harmony default export */


    var metrics_onTimeToInteractive = onTimeToInteractive_onTimeToInteractive; // CONCATENATED MODULE: ./src/metrics/onWindowOnLoad.js

    var onWindowOnLoad_onWindowOnLoad = function onWindowOnLoad(response) {
      getWindowLoad().then(function (windowLoad) {
        return response(windowLoad);
      });
    };
    /* harmony default export */


    var metrics_onWindowOnLoad = onWindowOnLoad_onWindowOnLoad; // CONCATENATED MODULE: ./src/metrics/getBenchmark.js
    // https://github.com/GoogleChrome/lighthouse/blob/925cb1d6a489178ee20d5727a586508dbd070245/lighthouse-core/lib/page-functions.js#L189

    function benchmarkIndexGC() {
      var start = Date.now();
      var iterations = 0;

      while (Date.now() - start < 250) {
        // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
        var s = '';

        for (var j = 0; j < 10000; j++) {
          s += 'a';
        }

        iterations++;
      }

      var durationInSeconds = (Date.now() - start) / 1000;
      return Math.round(iterations / 10 / durationInSeconds);
    } // https://github.com/GoogleChrome/lighthouse/blob/925cb1d6a489178ee20d5727a586508dbd070245/lighthouse-core/lib/page-functions.js#L209


    function benchmarkIndexNoGC() {
      var arrA = [];
      var arrB = []; // eslint-disable-next-line no-multi-assign

      for (var i = 0; i < 100000; i++) {
        arrA[i] = arrB[i] = i;
      }

      var start = Date.now();
      var iterations = 0;

      while (iterations % 10 !== 0 || Date.now() - start < 250) {
        var src = iterations % 2 === 0 ? arrA : arrB;
        var tgt = iterations % 2 === 0 ? arrB : arrA;

        for (var j = 0; j < src.length; j++) {
          tgt[j] = src[j];
        }

        iterations++;
      }

      var durationInSeconds = (Date.now() - start) / 1000;
      return Math.round(iterations / 10 / durationInSeconds);
    }

    function benchmark() {
      return (benchmarkIndexGC() + benchmarkIndexNoGC()) / 2;
    }

    var benchmarkPromise = src_defer();

    if (typeof document !== 'undefined') {
      document.addEventListener("DOMContentLoaded", function () {
        benchmarkPromise.resolve(benchmark());
      });
    }

    var getBenchmark = function getBenchmark() {
      return benchmarkPromise.promise;
    };
    /* harmony default export */


    var metrics_getBenchmark = getBenchmark; // CONCATENATED MODULE: ./src/metrics/onBenchmark.js

    var onBenchmark_onBenchmark = function onBenchmark(response) {
      metrics_getBenchmark().then(function (value) {
        return response(value);
      });
    };
    /* harmony default export */


    var metrics_onBenchmark = onBenchmark_onBenchmark; // CONCATENATED MODULE: ./src/metrics/index.js

    var metrics_reportMetrics = function reportMetrics(report) {
      var fullResponse = function fullResponse(name, unit) {
        return function (value) {
          return report(name, value, unit);
        };
      };

      metrics_onCumulativeLayoutShift(fullResponse('cumulative-layout-shift', ''));
      metrics_onDomComplete(fullResponse('dom-complete', 'ms'));
      metrics_onDomInteractive(fullResponse('dom-interactive', 'ms'));
      metrics_onDomLoading(fullResponse('dom-loading', 'ms'));
      metrics_onFirstContentfulPaint(fullResponse('first-contentful-paint', 'ms'));
      metrics_onFirstInputDelay(fullResponse('first-input-delay', 'ms'));
      metrics_onLargestContentfulPaint(fullResponse('largest-contentful-paint', 'ms'));
      metrics_onTimeToFirstByte(fullResponse('time-to-first-byte', 'ms'));
      metrics_onTimeToInteractive(fullResponse('time-to-interactive', 'ms'));
      metrics_onWindowOnLoad(fullResponse('window-on-load', 'ms'));
      metrics_onBenchmark(fullResponse('cpu-benchmark', 'ops'));
    };
    /* harmony default export */


    var metrics = metrics_reportMetrics; // CONCATENATED MODULE: ./src/sendBeacon.js

    var sendBeacon = function sendBeacon(url, data) {
      try {
        var dataAsString = JSON.stringify(data);
        navigator.sendBeacon(url, dataAsString);
      } catch (_unused) {// leaving empty for now, we could perhaps provide a way to send this signal up
      }
    };
    /* harmony default export */


    var src_sendBeacon = sendBeacon; // CONCATENATED MODULE: ./src/getCookie.js

    /* eslint-disable no-useless-escape */

    var getCookie = function getCookie(name) {
      function escape(s) {
        return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1');
      }

      var match = document.cookie.match(RegExp("(?:^|;\\s*)" + escape(name) + "=([^;]*)"));
      return match ? match[1] : null;
    };
    /* harmony default export */


    var src_getCookie = getCookie; // CONCATENATED MODULE: ./src/visitorContext/getBrowserCookieId.js

    var getBrowserCookieId_getBrowserCookieId = function getBrowserCookieId() {
      return src_getCookie('BrowserCookieId');
    };
    /* harmony default export */


    var visitorContext_getBrowserCookieId = getBrowserCookieId_getBrowserCookieId; // CONCATENATED MODULE: ./src/visitorContext/getCarvanaUserId.js

    var getCarvanaUserId_getCarvanaUserId = function getCarvanaUserId() {
      var limitedAccessToken = src_getCookie('CVLimitedAccessToken');

      if (limitedAccessToken && limitedAccessToken.length) {
        var tokenObject = JSON.parse(limitedAccessToken);
        return tokenObject.user;
      }

      return null;
    };
    /* harmony default export */


    var visitorContext_getCarvanaUserId = getCarvanaUserId_getCarvanaUserId; // CONCATENATED MODULE: ./src/visitorContext/getUserAgent.js

    var getUserAgent = function getUserAgent() {
      return window.navigator.userAgent;
    };
    /* harmony default export */


    var visitorContext_getUserAgent = getUserAgent; // CONCATENATED MODULE: ./src/visitorContext/index.js

    var visitorContext_getVisitorContext = function getVisitorContext() {
      return {
        browser_cookie_id: visitorContext_getBrowserCookieId(),
        user_id: visitorContext_getCarvanaUserId(),
        user_agent: visitorContext_getUserAgent()
      };
    };
    /* harmony default export */


    var visitorContext = visitorContext_getVisitorContext; // CONCATENATED MODULE: ./src/memo.js

    var memoed = null;

    var memo = function memo(toMemo) {
      if (memoed === null) {
        memoed = toMemo();
      }

      return memoed;
    };
    /* harmony default export */


    var src_memo = memo; // CONCATENATED MODULE: ./src/browserContext/getBrowserName.js

    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
      try {
        var info = gen[key](arg);
        var value = info.value;
      } catch (error) {
        reject(error);
        return;
      }

      if (info.done) {
        resolve(value);
      } else {
        Promise.resolve(value).then(_next, _throw);
      }
    }

    function _asyncToGenerator(fn) {
      return function () {
        var self = this,
            args = arguments;
        return new Promise(function (resolve, reject) {
          var gen = fn.apply(self, args);

          function _next(value) {
            asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
          }

          function _throw(err) {
            asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
          }

          _next(undefined);
        });
      };
    }

    var getBrowserName = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getDeviceData) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getDeviceData();

              case 2:
                return _context.abrupt("return", _context.sent.browserName);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getBrowserName(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    /* harmony default export */


    var browserContext_getBrowserName = getBrowserName; // CONCATENATED MODULE: ./src/browserContext/getBrowserResolution.js

    var getBrowserResolution = function getBrowserResolution() {
      return window.innerWidth + "x" + window.innerHeight;
    };
    /* harmony default export */


    var browserContext_getBrowserResolution = getBrowserResolution; // CONCATENATED MODULE: ./src/browserContext/getCurrentRoute.js

    var getCurrentRoute = function getCurrentRoute() {
      return window.location.href;
    };
    /* harmony default export */


    var browserContext_getCurrentRoute = getCurrentRoute; // CONCATENATED MODULE: ./src/browserContext/getDeviceCategory.js

    function getDeviceCategory_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
      try {
        var info = gen[key](arg);
        var value = info.value;
      } catch (error) {
        reject(error);
        return;
      }

      if (info.done) {
        resolve(value);
      } else {
        Promise.resolve(value).then(_next, _throw);
      }
    }

    function getDeviceCategory_asyncToGenerator(fn) {
      return function () {
        var self = this,
            args = arguments;
        return new Promise(function (resolve, reject) {
          var gen = fn.apply(self, args);

          function _next(value) {
            getDeviceCategory_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
          }

          function _throw(err) {
            getDeviceCategory_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
          }

          _next(undefined);
        });
      };
    }

    var getDeviceCategory = /*#__PURE__*/function () {
      var _ref = getDeviceCategory_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getDeviceData) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getDeviceData();

              case 2:
                return _context.abrupt("return", _context.sent.primaryHardwareType);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getDeviceCategory(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    /* harmony default export */


    var browserContext_getDeviceCategory = getDeviceCategory; // CONCATENATED MODULE: ./src/browserContext/getDeviceName.js

    function getDeviceName_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
      try {
        var info = gen[key](arg);
        var value = info.value;
      } catch (error) {
        reject(error);
        return;
      }

      if (info.done) {
        resolve(value);
      } else {
        Promise.resolve(value).then(_next, _throw);
      }
    }

    function getDeviceName_asyncToGenerator(fn) {
      return function () {
        var self = this,
            args = arguments;
        return new Promise(function (resolve, reject) {
          var gen = fn.apply(self, args);

          function _next(value) {
            getDeviceName_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
          }

          function _throw(err) {
            getDeviceName_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
          }

          _next(undefined);
        });
      };
    }

    var getDeviceName = /*#__PURE__*/function () {
      var _ref = getDeviceName_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getDeviceData) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getDeviceData();

              case 2:
                return _context.abrupt("return", _context.sent.model);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getDeviceName(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    /* harmony default export */


    var browserContext_getDeviceName = getDeviceName; // CONCATENATED MODULE: ./src/browserContext/getLanguage.js

    function getLanguage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
      try {
        var info = gen[key](arg);
        var value = info.value;
      } catch (error) {
        reject(error);
        return;
      }

      if (info.done) {
        resolve(value);
      } else {
        Promise.resolve(value).then(_next, _throw);
      }
    }

    function getLanguage_asyncToGenerator(fn) {
      return function () {
        var self = this,
            args = arguments;
        return new Promise(function (resolve, reject) {
          var gen = fn.apply(self, args);

          function _next(value) {
            getLanguage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
          }

          function _throw(err) {
            getLanguage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
          }

          _next(undefined);
        });
      };
    }

    var getLanguage = /*#__PURE__*/function () {
      var _ref = getLanguage_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getDeviceData) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getDeviceData();

              case 2:
                return _context.abrupt("return", _context.sent.language);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getLanguage(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    /* harmony default export */


    var browserContext_getLanguage = getLanguage; // CONCATENATED MODULE: ./src/browserContext/getOsName.js

    function getOsName_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
      try {
        var info = gen[key](arg);
        var value = info.value;
      } catch (error) {
        reject(error);
        return;
      }

      if (info.done) {
        resolve(value);
      } else {
        Promise.resolve(value).then(_next, _throw);
      }
    }

    function getOsName_asyncToGenerator(fn) {
      return function () {
        var self = this,
            args = arguments;
        return new Promise(function (resolve, reject) {
          var gen = fn.apply(self, args);

          function _next(value) {
            getOsName_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
          }

          function _throw(err) {
            getOsName_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
          }

          _next(undefined);
        });
      };
    }

    var getOsName = /*#__PURE__*/function () {
      var _ref = getOsName_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getDeviceData) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getDeviceData();

              case 2:
                return _context.abrupt("return", _context.sent.osName);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getOsName(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    /* harmony default export */


    var browserContext_getOsName = getOsName; // CONCATENATED MODULE: ./src/browserContext/getScreenResolution.js

    /* eslint-disable no-restricted-globals */

    var getScreenResolution = function getScreenResolution() {
      return screen.width + "x" + screen.height;
    };
    /* harmony default export */


    var browserContext_getScreenResolution = getScreenResolution; // CONCATENATED MODULE: ./src/browserContext/index.js

    function browserContext_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
      try {
        var info = gen[key](arg);
        var value = info.value;
      } catch (error) {
        reject(error);
        return;
      }

      if (info.done) {
        resolve(value);
      } else {
        Promise.resolve(value).then(_next, _throw);
      }
    }

    function browserContext_asyncToGenerator(fn) {
      return function () {
        var self = this,
            args = arguments;
        return new Promise(function (resolve, reject) {
          var gen = fn.apply(self, args);

          function _next(value) {
            browserContext_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
          }

          function _throw(err) {
            browserContext_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
          }

          _next(undefined);
        });
      };
    }

    var getBrowserContext = /*#__PURE__*/function () {
      var _ref = browserContext_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(rawGetDeviceData) {
        var getDeviceData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                getDeviceData = function getDeviceData() {
                  return src_memo(function () {
                    return rawGetDeviceData();
                  });
                };

                _context.next = 3;
                return browserContext_getCurrentRoute(getDeviceData);

              case 3:
                _context.t0 = _context.sent;
                _context.next = 6;
                return browserContext_getBrowserName(getDeviceData);

              case 6:
                _context.t1 = _context.sent;
                _context.next = 9;
                return browserContext_getOsName(getDeviceData);

              case 9:
                _context.t2 = _context.sent;
                _context.next = 12;
                return browserContext_getDeviceCategory(getDeviceData);

              case 12:
                _context.t3 = _context.sent;
                _context.next = 15;
                return browserContext_getDeviceName(getDeviceData);

              case 15:
                _context.t4 = _context.sent;
                _context.next = 18;
                return browserContext_getLanguage(getDeviceData);

              case 18:
                _context.t5 = _context.sent;
                _context.next = 21;
                return browserContext_getScreenResolution(getDeviceData);

              case 21:
                _context.t6 = _context.sent;
                _context.next = 24;
                return browserContext_getBrowserResolution(getDeviceData);

              case 24:
                _context.t7 = _context.sent;
                return _context.abrupt("return", {
                  url: _context.t0,
                  browser_name: _context.t1,
                  os_name: _context.t2,
                  device_category: _context.t3,
                  device_name: _context.t4,
                  language: _context.t5,
                  screen_resolution: _context.t6,
                  browser_resolution: _context.t7
                });

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getBrowserContext(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    /* harmony default export */


    var browserContext = getBrowserContext; // CONCATENATED MODULE: ./src/trackerContext/index.js

    var getTrackerContext = function getTrackerContext(team, project) {
      return {
        team: team,
        project: project
      };
    };
    /* harmony default export */


    var trackerContext = getTrackerContext; // CONCATENATED MODULE: ./src/envelope/index.js

    function envelope_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
      try {
        var info = gen[key](arg);
        var value = info.value;
      } catch (error) {
        reject(error);
        return;
      }

      if (info.done) {
        resolve(value);
      } else {
        Promise.resolve(value).then(_next, _throw);
      }
    }

    function envelope_asyncToGenerator(fn) {
      return function () {
        var self = this,
            args = arguments;
        return new Promise(function (resolve, reject) {
          var gen = fn.apply(self, args);

          function _next(value) {
            envelope_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
          }

          function _throw(err) {
            envelope_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
          }

          _next(undefined);
        });
      };
    }

    var envelope_getEnvelope = /*#__PURE__*/function () {
      var _ref = envelope_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(team, project, getDeviceData) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return visitorContext();

              case 2:
                _context.t0 = _context.sent;
                _context.next = 5;
                return browserContext(getDeviceData);

              case 5:
                _context.t1 = _context.sent;
                _context.next = 8;
                return trackerContext(team, project);

              case 8:
                _context.t2 = _context.sent;
                return _context.abrupt("return", {
                  visitor_context: _context.t0,
                  browser_context: _context.t1,
                  tracker_context: _context.t2
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getEnvelope(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();
    /* harmony default export */


    var src_envelope = envelope_getEnvelope; // EXTERNAL MODULE: external "uuid"

    var external_uuid_ = __webpack_require__("uuid"); // CONCATENATED MODULE: ./src/correlationId.js


    var correlationId = Object(external_uuid_["v4"])();
    /* harmony default export */

    var src_correlationId = correlationId; // CONCATENATED MODULE: ./src/constructData.js

    function _extends() {
      _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      return _extends.apply(this, arguments);
    }

    var constructData_constructData = function constructData(correlationId, envelope, data) {
      return _extends({
        correlation_id: correlationId
      }, envelope, {}, data);
    };
    /* harmony default export */


    var src_constructData = constructData_constructData; // CONCATENATED MODULE: ./src/getDeviceData.js

    var getDeviceData_getDeviceData = function getDeviceData(endpointUrl) {
      if (endpointUrl === void 0) {
        endpointUrl = "https://apim.carvana.io/device-detection/api/v1/devicedetection";
      }

      return new Promise(function (resolve, reject) {
        var httpRequest = new XMLHttpRequest();

        httpRequest.onreadystatechange = function () {
          if (httpRequest.readyState === XMLHttpRequest.DONE) {
            if (httpRequest.status === 200) {
              resolve(JSON.parse(httpRequest.responseText));
            } else {
              reject(httpRequest.responseText);
            }
          }
        };

        httpRequest.open('GET', endpointUrl);
        httpRequest.send();
      });
    };
    /* harmony default export */


    var src_getDeviceData = getDeviceData_getDeviceData; // CONCATENATED MODULE: ./src/index.js

    /* harmony export (binding) */

    __webpack_require__.d(__webpack_exports__, "default", function () {
      return src_startTracking;
    });
    /* concated harmony reexport sendData */


    __webpack_require__.d(__webpack_exports__, "sendData", function () {
      return src_sendBeacon;
    });
    /* concated harmony reexport constructData */


    __webpack_require__.d(__webpack_exports__, "constructData", function () {
      return src_constructData;
    });
    /* concated harmony reexport getEnvelope */


    __webpack_require__.d(__webpack_exports__, "getEnvelope", function () {
      return src_envelope;
    });
    /* concated harmony reexport getDeviceData */


    __webpack_require__.d(__webpack_exports__, "getDeviceData", function () {
      return src_getDeviceData;
    });

    function src_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
      try {
        var info = gen[key](arg);
        var value = info.value;
      } catch (error) {
        reject(error);
        return;
      }

      if (info.done) {
        resolve(value);
      } else {
        Promise.resolve(value).then(_next, _throw);
      }
    }

    function src_asyncToGenerator(fn) {
      return function () {
        var self = this,
            args = arguments;
        return new Promise(function (resolve, reject) {
          var gen = fn.apply(self, args);

          function _next(value) {
            src_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
          }

          function _throw(err) {
            src_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
          }

          _next(undefined);
        });
      };
    }

    var getDataFromMetrics = function getDataFromMetrics(eventId, name, value, unit) {
      return {
        event_source_context: {
          event_source: 'page',
          event_action: 'none',
          event_name: 'performance',
          event_source_name: 'page',
          event_source_id: eventId,
          event_datetime: new Date()
        },
        custom_attributes: {
          name: name,
          value: value,
          unit: unit
        }
      };
    };

    var src_startTracking = function startTracking(url, team, project, _temp) {
      var _ref = _temp === void 0 ? {} : _temp,
          _ref$sendData = _ref.sendData,
          sendData = _ref$sendData === void 0 ? src_sendBeacon : _ref$sendData,
          _ref$constructData = _ref.constructData,
          constructData = _ref$constructData === void 0 ? src_constructData : _ref$constructData,
          _ref$getEnvelope = _ref.getEnvelope,
          getEnvelope = _ref$getEnvelope === void 0 ? src_envelope : _ref$getEnvelope,
          _ref$getDeviceData = _ref.getDeviceData,
          getDeviceData = _ref$getDeviceData === void 0 ? src_getDeviceData : _ref$getDeviceData;

      var eventId = team + "-" + project;

      var track = /*#__PURE__*/function () {
        var _ref2 = src_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
          var envelope, fullData;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return getEnvelope(team, project, getDeviceData);

                case 2:
                  envelope = _context.sent;
                  fullData = constructData(src_correlationId, envelope, data);
                  sendData(url, fullData);

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function track(_x) {
          return _ref2.apply(this, arguments);
        };
      }();

      if (typeof window !== 'undefined') {
        metrics(function (name, value, unit) {
          return track(getDataFromMetrics(eventId, name, value, unit));
        });
      }

      return track;
    };
    /***/

  },

  /***/
  "tti-polyfill":
  /***/
  function ttiPolyfill(module, exports) {
    module.exports = require("tti-polyfill");
    /***/
  },

  /***/
  "uuid":
  /***/
  function uuid(module, exports) {
    module.exports = require("uuid");
    /***/
  },

  /***/
  "web-vitals":
  /***/
  function webVitals(module, exports) {
    module.exports = require("web-vitals");
    /***/
  }
  /******/

});